module.exports = __webpack_public_path__ + "static/media/image_app_download_googleplay.b9ce4469.png";